import { Image } from '@react-pdf/renderer';
import JsBarcode from 'jsbarcode';
import React from 'react';

type BarcodeProps = {
  barcode: string;
};

export const Barcode = ({ barcode }: BarcodeProps): React.ReactNode => {
  const canvas = document.createElement('canvas');

  JsBarcode(canvas, barcode, {
    format: 'ITF',
    displayValue: false,
    height: 120,
  });
  const barcodeSrc = canvas.toDataURL();

  return <Image src={barcodeSrc} />;
};
